import type React from 'react';

import { type FocusableElement, tabbable } from 'tabbable';

export function findNextTabbableElementOutsideSuggestions({
  activeElm,
  recentSuggestionsRef,
  searchSuggestionsRef,
  trendingSuggestionsRef,
  userSuggestionsRef,
}: {
  activeElm: FocusableElement;
  recentSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  searchSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  trendingSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  userSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
}): FocusableElement | null {
  const allTabbableElms = tabbable(document.body);
  const suggestionContainers = [
    recentSuggestionsRef?.current,
    searchSuggestionsRef?.current,
    trendingSuggestionsRef?.current,
    userSuggestionsRef?.current,
  ].filter(Boolean) as HTMLElement[];

  // Find the next tabbable element that is not within any suggestion container
  // This skips all elements inside suggestions, including links and nested elements
  const currentIndex = allTabbableElms.indexOf(activeElm);
  const nextElement = allTabbableElms.slice(currentIndex + 1).find((elm) => {
    // Skip any element within suggestion containers
    return !suggestionContainers.some((container) => container.contains(elm));
  });

  return nextElement || null;
}
